import { render, staticRenderFns } from "./BlkTtyLim.vue?vue&type=template&id=00fed052&"
import script from "./BlkTtyLim.vue?vue&type=script&lang=js&"
export * from "./BlkTtyLim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports